////////////////////////////////////////////////////
//                                                //
//  ENDPOINT -> /checkout/?loja=                  //
//                                                //
//  PÁGINA EXCLUSIVA PARA CLIENTES PARA           //
//  O PAGAMENTO DAS COMPRAS REALIZADAS.           //
//                                                //
//  RECEBE COMO PARÂMETRO NA URL O ID             //
//  DA LOJA QUE ESTÁ VENDENDO OS PRODUTOS.        //
//                                                //
//////////////////////////////////////////////////// 


import React, {useState} from "react"

import Loader from '../components/loader'
import ContinuarComprando from  '../components/continuar_comprando'
import ItensComprados from  '../components/itens_comprados';
import ProdutosComprados from '../components/produtos_comprados'
import FormCartao from '../components/form_cartao'

import api from "../services/api";


function Checkout() {

  // ESTADOS DEFINIDOS
    // 'carrinho' = PRODUTOS NO CARRINHO

  let [carrinho, setCarrinho] = useState([])


  window.onload = async function() {
    // FUNÇÃO CHAMADA NO CARREGAMENTO DESTA PÁGINA ('/checkout/?loja=')

    carrinho_de_compras()  // DEFINE OS PRODUTOS CARRINHO DE COMPRAS

    var params = window.location.search 
    var urlparams = new URLSearchParams(params)
    var loja = urlparams.get('loja')
    
    if(loja != sessionStorage['loja']){  // VERIFICA SE A LOJA DA URL É A MESMA LOJA DA SESSION
      window.location.href = '/checkout/?loja='+ sessionStorage['loja']  // CASO NÃO SEJA, REDIRECIONA PARA A PÁGINA DA LOJA DA SESSION
    }
                   
  }

  async function carrinho_de_compras(){  // FUNÇÃO PARA BUSCAR OS PRODUTOS COMPRADOS
    // FUNÇÃO CHAMADA PELO ONLOAD DESTA PÁGINA

    if(sessionStorage['login']){  // VERIFICA SE O USUÁRIO ESTÁ LOGADO
      if(!sessionStorage['login'].includes('/')){  // E SE NÃO ESTÁ LOGADO COMO FRANQUEADO

        var resp = await api.post('buscar_interesses',{  // BUSCA NO DB OS PRODUTOS NO CARRINHO
          "usuario": sessionStorage['login'],
          "loja": sessionStorage['loja'],
        }).then((response) => {
          return response
        })      
        // resp['data'] RETORNA UM DICIONÁRIO COM AS CHAVES
          // 'fav' -> VAZIO POIS NADA ESTÁ FAVORITADO A PEDIDO DO DEPARTAMENTO DE MARKETING
          
          // 'car' -> LISTA COM OS PRODUTOS NO CARRINHO
              // CADA ITEM DE 'car' É UM DICIONÁRIO COM AS CHAVES
              // 'id' -> STRING COM O ID DO PRODUTO
              // id -> DICIONÁRIO COM OS DETALHES DO PRODUTO COM AS CHAVES
                // 'carrinho' -> INT COM A QUANTIDADE DE ITENS DESSE PRODUTO NO CARRINHO
                // 'estoque' -> INT COM QUANTOS PRODUTOS AINDA RESTAM EM ESTOQUE
                // 'img' -> STRING COM A URL DA IMAGEM DO PRODUTO
                // 'preco' -> FLOAT COM O PREÇO UNITÁRIO DO PRODUTO
          
      }
    }

    if(resp){  // CASO EXISTAM PRODUTOS NO CARRINHO
      setCarrinho(resp['data']['car'])  // DEFINE OS PRODUTOS NO ESTADO DA PÁGINA
    }
    else{  // CASO NÃO EXISTAM PRODUTOS NO CARRINHO
      setCarrinho([])  // DEFINE COMO VAZIO
    }
  }


  // CONDIÇÕES DE LOGIN
  if(!sessionStorage['login']){  // CASO O USUARIO NAO ESTEJA LOGADO
    window.location.href = '/?id='+ sessionStorage['loja']     
  }  
  else{
    if(sessionStorage['login'].includes('/')){  // OU ESTEJA LOGADO COMO FRANQUEADO E NÃO USUÁRIO
      window.location.href = '/?id='+ sessionStorage['loja']  // REDIRECIONA PARA A PÁGINA HOME
    }
    else{  // CASO ESTEJA LOGADO COMO FRANQUEADO RENDERIZA A PÁGINA

      // OS COMPONENTES DA PÁGINA SÃO (NA ORDEM QUE APARECEM):
        // 'Loader' -> APARECE ENQUANTO OS PRODUTOS NÃO SÃO CARREGADOS
        // 'ContinuarComprando' -> VERSÃO DO HEADER QUE NÃO APARECE A BARRA DE PESQUISA E SIM BOTÃO DE VOLTAR PARA A PÁGINA HOME
        // 'ItensComprados' -> ABA LATERAL DIREITA DO CARRINHO
        // 'ProdutosComprados' -> CARD NO TOPO COM A DESCRIÇÃO DOS PRODUTOS COMPRADOS
        // 'FormCartao' -> CARD EMBAIXO PARA PREENCHIMENTO DOS DADOS DO CARTÃO
    
      return (
        <div> 
          <div className="pt-35vh d-none" id="loader"> 
            <Loader />
          </div>

          <ContinuarComprando />

          <div>
            <ItensComprados props={carrinho} callback={carrinho_de_compras}/> 
          </div>

          <div class="custom-container start-page card-checkout">
            <ProdutosComprados props={carrinho}/>
          </div>    

          <div class="custom-container card-checkout my-5" id='infos_cartao'>
            <FormCartao props={carrinho} />
          </div>      

          <div class="custom-container card-checkout my-5 d-none" id='sucesso'>
            <div class="preco verde montserrat mt-3 mb-0 pb-2 font-x-larger px-5 border-bottom">
              Compra Efetuada com Sucesso
            </div>

            <div class='montserrat font-large pt-4 px-4'>
              Retire na loja grátis ou
            </div>  

            <div class='montserrat font-large pb-4 px-4'>
              Entre em contato com a loja para combinar a entrega
            </div>

          </div> 
        </div>
      )
    }
  }
}


export default Checkout;